var map = {
	"./404.svg": 954,
	"./Categories.png": 955,
	"./Edit-menu.svg": 956,
	"./Egg.svg": 957,
	"./Emaier-Header.png": 958,
	"./Qr-4.png": 959,
	"./_duplicate.svg": 960,
	"./_overview.svg": 961,
	"./add-white.svg": 962,
	"./alert.svg": 963,
	"./all_category.svg": 964,
	"./archive.svg": 965,
	"./armchair.svg": 966,
	"./arrow-circle-right.svg": 967,
	"./arrow-left-circle.svg": 968,
	"./arrow-right-circle.svg": 969,
	"./arrow-right.svg": 970,
	"./asc-up-white.svg": 971,
	"./asc.png": 972,
	"./asc.svg": 973,
	"./back-arrow.svg": 974,
	"./barcode-icon.svg": 975,
	"./beverages.svg": 976,
	"./blue-edit-pen.svg": 977,
	"./blue-eye.svg": 978,
	"./box-office.svg": 979,
	"./broken-seat.jpg": 980,
	"./calendar_list.svg": 981,
	"./calender.svg": 364,
	"./chevron-down.svg": 982,
	"./chevron-left.svg": 983,
	"./cinema-mamagement-sidebar.svg": 984,
	"./claendar.svg": 314,
	"./clock-1.svg": 985,
	"./clock.svg": 986,
	"./close-button.svg": 717,
	"./close-white.svg": 719,
	"./close-x.svg": 309,
	"./collapse-up.svg": 987,
	"./collapse.svg": 988,
	"./connection-lost.svg": 362,
	"./consumable-raw-material.svg": 989,
	"./copy.svg": 990,
	"./copy_image_icon.png": 991,
	"./delete-red-light.svg": 992,
	"./delete-red.svg": 726,
	"./delete.svg": 700,
	"./deliver-icon.svg": 993,
	"./desc-down-white.svg": 994,
	"./desc.svg": 995,
	"./distributors-sidebar.svg": 996,
	"./download.svg": 997,
	"./dragndrop.svg": 998,
	"./dragndrop2.svg": 999,
	"./duplicate.svg": 1000,
	"./duplicateScreen.svg": 1001,
	"./e-wallet-icon-black.svg": 1002,
	"./edit-pen-blue.svg": 1003,
	"./edit-pen-white.svg": 1004,
	"./edit-pen.svg": 1005,
	"./edit.svg": 1006,
	"./email.png": 1007,
	"./empty-image.svg": 1008,
	"./excel.svg": 1009,
	"./external-link.svg": 1010,
	"./eye.svg": 1011,
	"./filter-icon.svg": 1012,
	"./flag.svg": 1013,
	"./fnb-app-order.svg": 1014,
	"./fnb-beverages.svg": 1015,
	"./fnb-brownie.svg": 1016,
	"./fnb-combo.svg": 1017,
	"./fnb-desert.svg": 1018,
	"./fnb-eatables.svg": 1019,
	"./fnb-make-your-combo.svg": 1020,
	"./fnb-popcorn.svg": 1021,
	"./fnbtransactionIcon.svg": 1022,
	"./fullscreen-icon.svg": 727,
	"./funnel.svg": 1023,
	"./globe.svg": 1024,
	"./green-tick.svg": 1025,
	"./grid-view.svg": 1026,
	"./hide-password.svg": 365,
	"./home-icon.svg": 1027,
	"./home.svg": 1028,
	"./icon-black-play.svg": 1029,
	"./icon-dot.svg": 1030,
	"./icon-fnb.svg": 1031,
	"./icon-marketing.svg": 1032,
	"./icon-no-seat.png": 1033,
	"./icon-no-seat.svg": 1034,
	"./icon-option.svg": 1035,
	"./icon-poin-of-sale.svg": 1036,
	"./icon-recliner.svg": 1037,
	"./icon-report.svg": 1038,
	"./icon-sofa-dark-1.svg": 1039,
	"./icon-sofa-dark.png": 1040,
	"./icon-sofa-dark.svg": 1041,
	"./icon-sofa.svg": 1042,
	"./importfile.svg": 1043,
	"./info.svg": 720,
	"./info2.svg": 1044,
	"./keyboard-icon.svg": 1045,
	"./kitchen_display.svg": 1046,
	"./language-icon.svg": 366,
	"./left-caret.svg": 1047,
	"./link.svg": 1048,
	"./list-view.svg": 1049,
	"./loading.svg": 367,
	"./lock.svg": 1050,
	"./login-password.png": 368,
	"./login-user.png": 369,
	"./logout.svg": 721,
	"./masters-sidebar.svg": 1051,
	"./merchandise.svg": 1052,
	"./minus.svg": 1053,
	"./movie-pass-svg.svg": 711,
	"./movie-rolling.svg": 1054,
	"./mulitSchedule.svg": 1055,
	"./multicurrency.svg": 1056,
	"./multifnb.svg": 1057,
	"./nav-plus.svg": 1058,
	"./new_filter_icon.svg": 1059,
	"./no-image.svg": 1060,
	"./no-schedule.svg": 142,
	"./non-veg-mark.png": 1061,
	"./non-veg-mark.svg": 1062,
	"./notification.svg": 1063,
	"./open-link-blue.svg": 1064,
	"./openPlanned.svg": 1065,
	"./overview.svg": 1066,
	"./overview2.svg": 1067,
	"./pdf-icon.svg": 1068,
	"./pdf.svg": 1069,
	"./pickup-ticket-icon.svg": 1070,
	"./pickupfnb.svg": 1071,
	"./play.svg": 1072,
	"./plus.svg": 1073,
	"./pointofsale-1.svg": 1074,
	"./pointofsale-2.svg": 1075,
	"./pointofsale.png": 1076,
	"./portfolio.svg": 1077,
	"./pos-fnb-no-itmes.svg": 713,
	"./pos-refresh.svg": 1078,
	"./primary/chevron-down.svg": 1079,
	"./primary/download.svg": 1080,
	"./primary/edit.svg": 1081,
	"./primary/filter.svg": 1082,
	"./primary/printer.svg": 1083,
	"./print-icon.svg": 1084,
	"./print.svg": 1085,
	"./question.svg": 1086,
	"./question1.svg": 1087,
	"./question2.svg": 728,
	"./question3.svg": 1088,
	"./recliner-1.svg": 1089,
	"./recliner.png": 1090,
	"./refund-icon.svg": 1091,
	"./reload-icon-pos.svg": 1092,
	"./reload-icon.svg": 1093,
	"./restore.svg": 1094,
	"./right-caret.svg": 1095,
	"./role-management-sidebar.svg": 1096,
	"./save.svg": 1097,
	"./schedule-icon.svg": 1098,
	"./school-calendar.svg": 1099,
	"./search-global-white.svg": 1100,
	"./search-global.svg": 1101,
	"./search.svg": 729,
	"./searchIcon.svg": 1102,
	"./seat-icon-2.svg": 1103,
	"./seat-icon.svg": 1104,
	"./seat-icons/3-wheelChair.png": 1105,
	"./seat-icons/block_seat_new.png": 1106,
	"./seat-icons/broken-seat-1.svg": 1107,
	"./seat-icons/broken-seat-2.svg": 1108,
	"./select-food.png": 730,
	"./settings.svg": 1109,
	"./show-password.svg": 370,
	"./slider-triangle.svg": 722,
	"./snack.svg": 723,
	"./sort.svg": 1110,
	"./star-empty.svg": 1111,
	"./star-fill.svg": 1112,
	"./success-tick.svg": 1113,
	"./suitcase.svg": 1114,
	"./swap.svg": 1115,
	"./tick-green-item.svg": 731,
	"./tick-green.svg": 1116,
	"./ticket-icon.svg": 1117,
	"./trash.svg": 1118,
	"./unpaid-reservation.svg": 705,
	"./updown-white.svg": 1119,
	"./updown.svg": 1120,
	"./user-attribute.svg": 1121,
	"./user-attributes.svg": 1122,
	"./user-female.svg": 1123,
	"./user-male-white.svg": 1124,
	"./user-male.svg": 1125,
	"./user-profile.svg": 1126,
	"./userProfile.png": 1127,
	"./veg-food-mark-white.png": 1128,
	"./veg-foog-mark-trans.png": 1129,
	"./view.png": 1130,
	"./view.svg": 1131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 953;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 953
// module chunks = 37